module.exports = __webpack_public_path__ + "static/media/cart-old.69a6eccc.png";